import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intrebari-frecvente',
  templateUrl: './intrebari-frecvente.component.html',
  styleUrls: ['./intrebari-frecvente.component.scss']
})


export class IntrebariFrecventeComponent implements OnInit {

  breadCrumbItems: Array<{}>;
  constructor() { }

  ngOnInit() {
  }

}
